import { useCallback, useEffect, useRef, useState } from 'react';

export const useStoryMediaReady = ({ active, slideKey, isSliding }) => {
	const slideKeyRef = useRef(slideKey);
	const [loadedSlideKey, setLoadedSlideKey] = useState(null);
	const [loadedMeta, setLoadedMeta] = useState(null);

	slideKeyRef.current = slideKey;

	useEffect(() => {
		if (!active) {
			setLoadedSlideKey(null);
			setLoadedMeta(null);
		}
	}, [active]);

	const handleMediaReady = useCallback((forSlideKey, meta = null) => {
		if (!forSlideKey || forSlideKey !== slideKeyRef.current) {
			return;
		}

		setLoadedSlideKey(forSlideKey);
		setLoadedMeta(meta);
	}, []);

	const mediaReady = active && !isSliding && loadedSlideKey === slideKey;
	const isVideo = Boolean(loadedMeta?.isVideo && loadedSlideKey === slideKey);

	return {
		mediaReady,
		isVideo,
		handleMediaReady,
	};
};
